import { getQuantityType } from "../../components/dms_common/DmsUtils";
import { getDataFromLocalDb } from "../../services/dbService";
import { DownloadSingleReportConfig, manageOrderRowsData } from "../../types/types";
import { setRealTimeStockDataInDb } from "../stocks/RealTimeStock/RealTimeStockUtils";
import { createSkuWiseStockMap, getBatchCodeQuantities, getBatchCodes } from "../viewOrder/ViewOrderUtils";

export const manageInvoiceColumnsMetaData = {
  columns: [
    {
      headerName: "Invoice No. & Date",
      headerParts: { top: "Invoice No.", bottom: "& date" },
      mappedValue: "invoiceNumber, creationTime",
      width: 190,
      headerAlign: "left",
      align: "left",
      truncateText: true,
    },
    {
      headerName: "Outlet Name & Code",
      headerParts: { top: "Outlet Name ", bottom: "& Code" },

      mappedValue: "outletName, outletCode",
      width: 200,
      headerAlign: "left",
      align: "left",
      truncateText: true,
    },
    {
      headerName: "SalesRep Name & ID",
      headerParts: { top: "SalesRep Name ", bottom: "& ID" },
      mappedValue: "salesRepName, salesRepId",
      width: 210,
      headerAlign: "left",
      align: "left",
      truncateText: true,
    },
    {
      headerName: "Quantity",
      mappedValue: "totalCaseQuantity, totalPieceQuantity, totalOtherUnitQuantity",
      width: 150,
      headerAlign: "left",
      align: "left",
      type: "order",
    },
    {
      headerName: "Amount",
      mappedValue: "netAmount",
      width: 120,
      headerAlign: "left",
      align: "left",
    },
    // {
    //   headerName: "Order Source",
    //   headerParts: { top: "Order", bottom: "source" },
    //   mappedValue: "source",
    //   width: 120,
    //   headerAlign: "left",
    //   align: "left",
    //   truncateText: true,
    // },
    {
      headerName: "Invoice Status",
      mappedValue: "status",
      width: 160,
      headerAlign: "left",
      align: "left",
    },
  ],
  Actions: ["view", "download"],
};

export const manageOrderColumnsMetaData = () => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const {
    mergeManageOrderInvoice,
    showOperationType,
    showRouteNameId,
    showRouteIdOnly,
    showLocationIdOnly,
    showOutletGstinLabelManageOrders
  } = ConfigDictionary;

  return {
  columns: [
    {
      headerName: mergeManageOrderInvoice ? "Reference No. & Date" :"Order No. & Date",
      headerParts: { top: mergeManageOrderInvoice ? "Reference No." : "Order No.", bottom: "& Date" },
      mappedValue: mergeManageOrderInvoice ? "refNo,creationTime" : "orderNumber,creationTime",
      width: 190,
      headerAlign: "left",
      align: "left",
      truncateText: true,
    },
    ...(showOperationType
      ? [
        {
          headerName: "Operation Type",
          headerParts: { top: "Operation", bottom: "Type" },
          mappedValue: "operationType",
          width: 130,
          headerAlign: "left",
          align: "left",
          truncateText: true,
        },
        ]
      : []),
    {
      headerName: "Outlet Name & Code",
      headerParts: { top: "Outlet Name ", bottom: "& Code" },

      mappedValue: "outletName, outletCode",
      width: 200,
      headerAlign: "left",
      align: "left",
      truncateText: true,
      showOutletGstinSvg: showOutletGstinLabelManageOrders
    },
    {
      headerName: "SalesRep Name & ID",
      headerParts: { top: "SalesRep Name ", bottom: "& ID" },
      mappedValue: "salesRepName, salesRepId",
      width: 180,
      headerAlign: "left",
      align: "left",
      truncateText: true,
    },
    ...(showRouteIdOnly ?
      [
        {
          headerName: "Route ID",
          mappedValue: "routeId",
          width: 140,
          headerAlign: "left",
          align: "left",
          truncateText: true,
        },
      ]:
      []
    ),
    ...(showLocationIdOnly ?
      [
        {
          headerName: "Location ID",
          mappedValue: "locationId",
          width: 140,
          headerAlign: "left",
          align: "left",
          truncateText: true,
        },
      ]:
      []
    ),
    ...(showRouteNameId
      ? [
        {
          headerName: "Route Name & ID",
          headerParts: { top: "Route Name ", bottom: "& ID" },
          mappedValue: "routeName, routeId",
          width: 140,
          headerAlign: "left",
          align: "left",
          truncateText: true,
        },
        ]
      : []),
    {
      headerName: "Quantity",
      mappedValue: "totalCaseQuantity, totalPieceQuantity, totalOtherUnitQuantity",
      width: 150,
      headerAlign: "left",
      align: "left",
      type: "order",
    },
    {
      headerName: "Amount",
      mappedValue: "netAmount",
      width: 120,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Order Source",
      headerParts: { top: "Order", bottom: "source" },
      mappedValue: "source",
      width: 105,
      headerAlign: "left",
      align: "left",
      truncateText: true,
    },
    {
      headerName: "Status",
      mappedValue: "status",
      width: 180,
      headerAlign: "left",
      align: "left",
    },
  ],
  Actions: ["view", "download"],
  }
};



export const bulkConfirmColumnsMetaData = () => {

  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const {
    showRouteIdOnly,
    showLocationIdOnly,
    showStatusReasonColumnBulkConfirm
  } = ConfigDictionary;

  return {
    columns: [
    {
      headerName: "Order No. & Date",
      headerParts: { top: "Order No.", bottom: "& Date" },
      mappedValue: "orderNumber,creationTime",
      width: 190,
      headerAlign: "left",
      align: "left",
      truncateText: true,
    },
    {
      headerName: "Outlet Name & Code",
      headerParts: { top: "Outlet Name ", bottom: "& Code" },

      mappedValue: "outletName, outletCode",
      width: 200,
      headerAlign: "left",
      align: "left",
      truncateText: true,
    },
    {
      headerName: "SalesRep Name & ID",
      headerParts: { top: "SalesRep Name ", bottom: "& ID" },
      mappedValue: "salesRepName, salesRepId",
      width: 180,
      headerAlign: "left",
      align: "left",
      truncateText: true,
    },
    ...(showRouteIdOnly ?
      [
        {
          headerName: "Route ID",
          mappedValue: "routeId",
          width: 140,
          headerAlign: "left",
          align: "left",
          truncateText: true,
        },
      ]:
      []
    ),
    ...(showLocationIdOnly ?
      [
        {
          headerName: "Location ID",
          mappedValue: "locationId",
          width: 140,
          headerAlign: "left",
          align: "left",
          truncateText: true,
        },
      ]:
      []
    ),
    {
      headerName: "Quantity",
      mappedValue: "totalCaseQuantity, totalPieceQuantity, totalOtherUnitQuantity",
      width: 150,
      headerAlign: "left",
      align: "left",
      type: "order",
    },
    {
      headerName: "Amount",
      mappedValue: "netAmount",
      width: 120,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Order Source",
      headerParts: { top: "Order", bottom: "source" },
      mappedValue: "source",
      width: 105,
      headerAlign: "left",
      align: "left",
      truncateText: true,
    },
    {
      headerName: "Order Status",
      headerParts: { top: "Order", bottom: "status" },
      mappedValue: "status",
      width: 180,
      headerAlign: "left",
      align: "left",
    },
    ...(showStatusReasonColumnBulkConfirm
      ? [
        {
          headerName: "Status Reason",
          headerParts: { top: "Status ", bottom: "Reason" },
          mappedValue: "statusReason",
          width: 200,
          headerAlign: "left",
          align: "left",
          truncateText: true,
        },
        ]
      : []),
  ],
  Actions: showStatusReasonColumnBulkConfirm ? [] : ["view", "download"],
}
};

export const manageOrderColumnsV2MetaData = () => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const {
    mergeManageOrderInvoice,
    showRouteNameId,
    showOutletGstinLabelManageOrders
  } = ConfigDictionary;

  return {
  columns: [
    {
      headerName: mergeManageOrderInvoice ? "Reference No. & Date" :"Order No. & Date",
      headerParts: { top: mergeManageOrderInvoice ? "Reference No." : "Order No.", bottom: "& Date" },
      mappedValue: mergeManageOrderInvoice ? "refNo,creationTime" : "orderNumber,creationTime",
      width: 190,
      headerAlign: "left",
      align: "left",
      truncateText: true,
      sortKey: "creationTime",
      sortType: "date"
    },
    {
      headerName: "Outlet Name & Code",
      headerParts: { top: "Outlet Name ", bottom: "& Code" },

      mappedValue: "outletName, outletCode",
      width: 200,
      headerAlign: "left",
      align: "left",
      truncateText: true,
      showOutletGstinSvg: showOutletGstinLabelManageOrders
    },
    {
      headerName: "SalesRep Name & ID",
      headerParts: { top: "SalesRep Name ", bottom: "& ID" },
      mappedValue: "salesRepName, salesRepId",
      width: 180,
      headerAlign: "left",
      align: "left",
      truncateText: true,
    },

    ...(showRouteNameId
      ? [
        {
          headerName: "Route Name & ID",
          headerParts: { top: "Route Name ", bottom: "& ID" },
          mappedValue: "routeName, routeId",
          width: 140,
          headerAlign: "left",
          align: "left",
          truncateText: true,
        },
        ]
      : []),
    {
      headerName: "Quantity",
      mappedValue: "totalCaseQuantity, totalPieceQuantity, totalOtherUnitQuantity",
      width: 230,
      headerAlign: "left",
      align: "left",
      type: "order",
      sortKey: "normalizedQuantity",
      sortType: "number"
    },
    {
      headerName: "Amount",
      mappedValue: "netAmount",
      width: 120,
      headerAlign: "left",
      align: "left",
      sortKey: "netAmount",
      sortType: "number"
    },
    {
      headerName: "Order Source",
      headerParts: { top: "Order", bottom: "Source" },
      mappedValue: "source",
      width: 105,
      headerAlign: "left",
      align: "left",
      truncateText: true,
    },
    {
      headerName: "Status",
      mappedValue: "status",
      width: 130,
      headerAlign: "left",
      align: "left",
    },
  ],
  Actions: ["view", "download"],
  }
};

export const bulkInvoiceModalColumnsMetaData = ()=> {
  return {
  columns: [
    {
      headerName: "Order ID",
      mappedValue:  "orderId",
      width: 200,
      headerAlign: "left",
      align: "left",
      truncateText: true,
    },
    {
      headerName: "Outlet Name & Code",
      headerParts: { top: "Outlet Name ", bottom: "& Code" },
      mappedValue: "outletName,outletCode",
      width: 200,
      headerAlign: "left",
      align: "left",
      truncateText: true,
    },
    {
      headerName: "Ordered Quantity",
      headerParts: { top: "Ordered ", bottom: "Quantity" },
      mappedValue: "totalCaseQuantity,totalPieceQuantity,totalOtherUnitQuantity",
      width: 230,
      headerAlign: "left",
      align: "left",
      type: "order",
      includeQty: true,
    },
    {
      headerName: "Allocated Quantity",
      headerParts: { top: "Allocated ", bottom: "Quantity" },
      mappedValue: "allocatedCaseQuantity,allocatedPieceQuantity,allocatedOtherUnitQuantity",
      width: 230,
      headerAlign: "left",
      align: "left",
      type: "order",
      includeQty: true,
    },
    {
      headerName: "Status",
      mappedValue: "bulkStatus",
      width: 150,
      headerAlign: "left",
      align: "left",
    }
  ],
  Actions: [""],
}
};

export const bulkInvoiceColumnsMetaData = ()=> {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const {
    mergeManageOrderInvoice,
    showRouteNameId,
    showOutletGstinLabelManageOrders,
  } = ConfigDictionary;


  return {
  columns: [
    {
      headerName: mergeManageOrderInvoice ? "Reference No. & Date" :"Order No. & Date",
      headerParts: { top: mergeManageOrderInvoice ? "Reference No." : "Order No.", bottom: "& Date" },
      mappedValue: mergeManageOrderInvoice ?  "refNo,creationTime" : "orderNumber,creationTime",
      width: 190,
      headerAlign: "left",
      align: "left",
      truncateText: true,
    },
    {
      headerName: "Outlet Name & Code",
      headerParts: { top: "Outlet Name ", bottom: "& Code" },

      mappedValue: "outletName, outletCode",
      width: 200,
      headerAlign: "left",
      align: "left",
      truncateText: true,
      showOutletGstinSvg: showOutletGstinLabelManageOrders
    },
    {
      headerName: "SalesRep Name & ID",
      headerParts: { top: "SalesRep Name ", bottom: "& ID" },
      mappedValue: "salesRepName, salesRepId",
      width: 180,
      headerAlign: "left",
      align: "left",
      truncateText: true,
    },
    ...(showRouteNameId
      ? [
        {
          headerName: "Route Name & ID",
          headerParts: { top: "Route Name ", bottom: "& ID" },
          mappedValue: "routeName, routeId",
          width: 140,
          headerAlign: "left",
          align: "left",
          truncateText: true,
        },
        ]
      : []),
    {
      headerName: "Quantity",
      mappedValue: "totalCaseQuantity, totalPieceQuantity, totalOtherUnitQuantity",
      width: 230,
      headerAlign: "left",
      align: "left",
      type: "order",
    },
    {
      headerName: "Amount",
      mappedValue: "netAmount",
      width: 120,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Order Source",
      headerParts: { top: "Order", bottom: "source" },
      mappedValue: "source",
      width: 105,
      headerAlign: "left",
      align: "left",
      truncateText: true,
    },
    {
      headerName: "Status",
      mappedValue: "status",
      width: 130,
      headerAlign: "left",
      align: "left",
    },
  ],
  Actions: ["view", "download"],
}
};

export const outletApprovalColumnsMetaData = (isCompanyPortal: boolean) => {
  return {
    columns: [
      {
        headerName: "Outlet Name & Code",
        headerParts: { top: "Outlet Name", bottom: "& Code" },
        mappedValue: "outletName, outletCode",
        width: 190,
        headerAlign: "left",
        align: "left",
        truncateText: true,
        keyAccountShow: true,
      },
      ...(isCompanyPortal ? [
          {
            headerName: "Distributor Name & Code",
            headerParts: { top: "Distributor Name", bottom: "& Code" },
            mappedValue: "distributorName, distributorId",
            width: 200,
            headerAlign: "left",
            align: "left",
            truncateText: true,
          }
        ]
        :
        []),
      {
        headerName: "SalesRep Name & ID",
        headerParts: { top: "SalesRep Name", bottom: "& ID" },
        mappedValue: "salesRepName, uniqueSalesRepId",
        width: 210,
        headerAlign: "left",
        align: "left",
        truncateText: true,
      },
      {
        headerName: "Outlet City",
        mappedValue: "outletCity",
        width: 150,
        headerAlign: "left",
        align: "left",
        type: "order",
      },
      {
        headerName: "Mobile No.",
        mappedValue: "outletMobileNumber",
        width: 150,
        headerAlign: "left",
        align: "left",
      },
      ...(!isCompanyPortal ? [
          {
            headerName: "Pincode",
            mappedValue: "outletPincode",
            width: 150,
            headerAlign: "left",
            align: "left",
          }
        ]
        :
        []),
      {
        headerName: "Source",
        mappedValue: "outletSource",
        width: 150,
        headerAlign: "left",
        align: "left",
      },
      {
        headerName: "Outlet Approval Status",
        headerParts: { top: "Outlet Approval", bottom: "Status" },
        mappedValue: "status",
        width: 160,
        headerAlign: "left",
        align: "left",
      },
    ],
    Actions: ["view"],
  }
}
export const getDownloadSingleReportConfig = (
  reportId: string,
  isArsReport?: boolean,
  filterKey?: string,
  filterValueKey?: string,
): DownloadSingleReportConfig => {
  const filters = [
    {
      key: filterKey ?? "orderNumber",
      value: filterValueKey ?? "orderNumber",
    },
  ];

  if (isArsReport) {
    filters.push({
      key: "source",
      value: "ars",
    });
  }

  return {
    reportId,
    filters,
  };
};

export const sortingStatusPriority = ["Pending", "Confirmed", "Partially Confirmed", "Partially Invoiced", "Invoiced", "Out For Delivery", "Delivered", "Partial Delivered",  "Rejected", "Cancelled"];


export const sortByCreationTime = (responseArray: manageOrderRowsData[]) =>
  responseArray.sort((a, b) => {
    const dateA = new Date(a.creationTime);
    const dateB = new Date(b.creationTime);
    return dateB.getTime() - dateA.getTime();
  });
  
export const sortBySatus = (responseArray: manageOrderRowsData[]) =>
  responseArray.sort((a, b) => {
    const priorityA = sortingStatusPriority.indexOf(a.status);
    const priorityB = sortingStatusPriority.indexOf(b.status);
    return priorityA - priorityB;
  });

export const getOrderSource = (order: manageOrderRowsData) => {
  const orderSource = order?.source?.toLowerCase();
  const loginId = order?.loginId;
  const outletCode = order?.outletCode;
  const subType = order?.subType?.toLowerCase();

  if (typeof order?.extendedAttributes?.designation == "string" && order?.extendedAttributes?.designation?.toLowerCase() == "stl") {
    return "STL";
  } else if (orderSource === "app order") {
    return loginId === outletCode ? "eB2B" : "SFA";
  } else {
    return orderSource?.toUpperCase();
  }
};

export const cancelIconStyles = {fill: "#868686", width: "18px", height: "auto", cursor: "pointer"}


type OrderNumberBatchCodesMapType = {
  [key: string]: string
}

export const performStockCheck = async (data: any) => {

  let allBatchCodesSet: Set<string> = new Set(); // Use a Set to store unique batch codes
  let batchCodeMap: OrderNumberBatchCodesMapType = {};

  for (const ro of data) {
    if (ro.status.toUpperCase() !== "PENDING") continue
    const orderedBatchCodes: string =
      getBatchCodes(ro["orderDetails"] ?? []) ?? [];
    const orderNumber = ro.orderNumber;

    batchCodeMap[orderNumber] = orderedBatchCodes;

    // Split batch codes and add to the Set to ensure uniqueness
    const codesArray = orderedBatchCodes
      .split(",")
      .map((code) => code.trim())
      .filter(Boolean);
    codesArray.forEach((code) => allBatchCodesSet.add(code));
  }

  let allBatchCodes = Array.from(allBatchCodesSet).join(",");

  if (allBatchCodes?.length === 0) return data;

  const BATCH_SIZE = 100;
  const allBatchCodesArray = allBatchCodes
    .split(",")
    .map((code) => code.trim())
    .filter(Boolean);

  let stocksData: any[] = [];

  for (let i = 0; i < allBatchCodesArray?.length; i += BATCH_SIZE) {
    const chunk = allBatchCodesArray.slice(i, i + BATCH_SIZE);
    const chunkString = chunk.join(",");

    const chunkStockData = await setRealTimeStockDataInDb(
      chunkString,
      getQuantityType(),
      undefined,
      undefined,
      "normal"
    );
    stocksData = stocksData.concat(chunkStockData);
  }

  let stocksDataResult = await createSkuWiseStockMap(stocksData);
  let stockBatchWiseMap = getBatchCodeQuantities( //contains uom wise stock for each skucode
    allBatchCodes,
    stocksDataResult
  );

  const ConfigDictionary = JSON.parse(
        localStorage.getItem("ConfigDictionary") ?? "{}"
      );
  const { uomConversion } = ConfigDictionary;
  const dbResult = await getDataFromLocalDb("Product");
  const products: any = dbResult?.data?.[0]?.data ?? {};
  const normalizedStockMap = new Map<string, number>(); //contains normalized stock for each skucode

  if (uomConversion) {
    // Convert Map entries to array for compatibility with older ES versions
    const stockBatchWiseEntries: Array<[string, [number, number, number]]> =
      [];
    stockBatchWiseMap.forEach((value, key) => {
      stockBatchWiseEntries.push([key, value]);
    });

    for (let i = 0; i < stockBatchWiseEntries.length; i++) {
      const [batchCode, quantities] = stockBatchWiseEntries[i];
      const product = products[batchCode];
      if (product) {
        const [avCs, avPi, avOth] = quantities;
        // Calculate normalized quantity based on product conversion factors
        const stockNormalizedQty =
          avCs * (product?.caseToPieceQuantity ?? 0) +
          avOth * (product?.otherUnitToPieceQuantity ?? 0) +
          avPi;

        // Store the normalized quantity for this batch code
        normalizedStockMap.set(batchCode, stockNormalizedQty);
      }
    }
  }
  for (const ro of data.sort(
      (a: any, b: any) =>
        new Date(a.creationTime).getTime() - new Date(b.creationTime).getTime()
    )) {
      if (ro.status.toUpperCase() !== "PENDING") continue
      let canFulfillCompletely = true;
      let canFulfillPartially = false;
      let hasAnyUnfulfillableItems = false;
      let unFulFillableItems: number = 0;

      // Deep clone the stockBatchWiseMap
      const tempStockMap = new Map<string, [number, number, number]>();
      stockBatchWiseMap.forEach((value, key) => {
        tempStockMap.set(key, [...value]);
      });

      // Clone the normalizedStockMap
      const tempNormalizedStockMap = new Map<string, number>();
      normalizedStockMap.forEach((value, key) => {
        tempNormalizedStockMap.set(key, value);
      });

      // Check availability for all items in this order
      for (const roo of ro["orderDetails"]) {
        let caseOQ = roo?.caseQuantity ?? 0;
        let pieceOQ = roo?.pieceQuantity ?? 0;
        let otherUnitOQ = roo?.otherUnitQuantity ?? 0;
        let batchCode = roo?.batchCode ?? "";
        if (roo?.type === "freeItem") continue
        let product = products[batchCode];

        if (uomConversion && product) {
          // Get or calculate normalized order quantity
          let orderDetailsNQ =
            roo?.normalizedQuantity ??
            caseOQ * (product?.caseToPieceQuantity ?? 0) +
              otherUnitOQ * (product?.otherUnitToPieceQuantity ?? 0) +
              pieceOQ;

          // Get normalized stock quantity
          let stockNQ = tempNormalizedStockMap.get(batchCode) ?? 0;

          if (stockNQ === 0) {
            canFulfillCompletely = false;

            // If we need items from this batch and there's no stock for this item
            if (orderDetailsNQ > 0) {
              unFulFillableItems++;
              // Don't break here, continue checking other items
            }
          } else if (stockNQ >= orderDetailsNQ) {
            // We can fulfill this item completely
            // If we have any items with stock, we can at least partially fulfill the order
            if (orderDetailsNQ > 0) {
              canFulfillPartially = true;
            }
          } else {
            // We can only partially fulfill this item
            canFulfillCompletely = false;

            // If there's any stock available and we need this item, we can partially fulfill
            if (orderDetailsNQ > 0 && stockNQ > 0) {
              canFulfillPartially = true;
            }
          }
        } else {
          // Original non-conversion logic
          let [avCs, avPi, avOth] = tempStockMap.has(batchCode)
            ? tempStockMap.get(batchCode) ?? [0, 0, 0]
            : [0, 0, 0];

          // Check if there's no stock at all for this batch code
          if (avCs === 0 && avPi === 0 && avOth === 0) {
            canFulfillCompletely = false;

            if (caseOQ > 0 || pieceOQ > 0 || otherUnitOQ > 0) {
              unFulFillableItems++;
              // Don't break here, continue checking other items
            }
          } else if (
            avCs >= caseOQ &&
            avPi >= pieceOQ &&
            avOth >= otherUnitOQ
          ) {
            // We can fulfill this item completely
            // If we have any items with stock, we can at least partially fulfill the order
            if (caseOQ > 0 || pieceOQ > 0 || otherUnitOQ > 0) {
              canFulfillPartially = true;
            }
          } else {
            canFulfillCompletely = false;

            if (
              (caseOQ > 0 && avCs > 0) ||
              (pieceOQ > 0 && avPi > 0) ||
              (otherUnitOQ > 0 && avOth > 0)
            ) {
              canFulfillPartially = true;
            }
          }
        }
      }

      hasAnyUnfulfillableItems = !(
        unFulFillableItems === ro["orderDetails"]?.length
      );
      ro.stockQuantityExceed = !canFulfillCompletely
  }
  return data
}

export interface StockCheckResult {
  confOrders: manageOrderRowsData[];
  parOrders: manageOrderRowsData[];
  canOrders: manageOrderRowsData[];
}

export const performStockCheckForBulkInvoicing = async (pendingOrdersData: any[]): Promise<StockCheckResult | null> => {
  pendingOrdersData = pendingOrdersData?.filter(order => order?.status?.toUpperCase() === "PENDING") || [];
  let allBatchCodesSet: Set<string> = new Set();
  let batchCodeMap: OrderNumberBatchCodesMapType = {};

  for (const ro of pendingOrdersData) {
    if (ro.status.toUpperCase() !== "PENDING") continue
    const orderedBatchCodes: string =
      getBatchCodes(ro["orderDetails"] ?? []) ?? [];
    const orderNumber = ro.orderNumber;

    batchCodeMap[orderNumber] = orderedBatchCodes;

    // Split batch codes and add to the Set to ensure uniqueness
    const codesArray = orderedBatchCodes
      .split(",")
      .map((code) => code.trim())
      .filter(Boolean);
    codesArray.forEach((code) => allBatchCodesSet.add(code));
  }

  let allBatchCodes = Array.from(allBatchCodesSet).join(",");

  if (allBatchCodes?.length === 0) return null;

  const BATCH_SIZE = 100;
  const allBatchCodesArray = allBatchCodes
    .split(",")
    .map((code) => code.trim())
    .filter(Boolean);

  let stocksData: any[] = [];

  for (let i = 0; i < allBatchCodesArray?.length; i += BATCH_SIZE) {
    const chunk = allBatchCodesArray.slice(i, i + BATCH_SIZE);
    const chunkString = chunk.join(",");

    const chunkStockData = await setRealTimeStockDataInDb(
      chunkString,
      getQuantityType(),
      undefined,
      undefined,
      "normal"
    );
    stocksData = stocksData.concat(chunkStockData);
  }

  let stocksDataResult = await createSkuWiseStockMap(stocksData);
  let stockBatchWiseMap = getBatchCodeQuantities( //contains uom wise stock for each skucode
    allBatchCodes,
    stocksDataResult
  );

  const ConfigDictionary = JSON.parse(
        localStorage.getItem("ConfigDictionary") ?? "{}"
      );
  const { uomConversion } = ConfigDictionary;
  const dbResult = await getDataFromLocalDb("Product");
  const products: any = dbResult?.data?.[0]?.data ?? {};
  const normalizedStockMap = new Map<string, number>(); //contains normalized stock for each skucode
  let confOrders: manageOrderRowsData[] = [];
  let parOrders: manageOrderRowsData[] = [];
  let canOrders: manageOrderRowsData[] = [];
  if (uomConversion) {
    // Convert Map entries to array for compatibility with older ES versions
    const stockBatchWiseEntries: Array<[string, [number, number, number]]> =
      [];
    stockBatchWiseMap.forEach((value, key) => {
      stockBatchWiseEntries.push([key, value]);
    });

    for (let i = 0; i < stockBatchWiseEntries.length; i++) {
      const [batchCode, quantities] = stockBatchWiseEntries[i];
      const product = products[batchCode];
      if (product) {
        const [avCs, avPi, avOth] = quantities;
        // Calculate normalized quantity based on product conversion factors
        const stockNormalizedQty =
          avCs * (product?.caseToPieceQuantity ?? 0) +
          avOth * (product?.otherUnitToPieceQuantity ?? 0) +
          avPi;

        // Store the normalized quantity for this batch code
        normalizedStockMap.set(batchCode, stockNormalizedQty);
      }
    }
  }

  for (const ro of pendingOrdersData.sort(
      (a, b) =>
        new Date(a.creationTime).getTime() - new Date(b.creationTime).getTime()
    )) {
      let canFulfillCompletely = true;
      let canFulfillPartially = false;
      let hasAnyUnfulfillableItems = false;
      let unFulFillableItems: number = 0;

      // Deep clone the stockBatchWiseMap
      const tempStockMap = new Map<string, [number, number, number]>();
      stockBatchWiseMap.forEach((value, key) => {
        tempStockMap.set(key, [...value]);
      });

      // Clone the normalizedStockMap
      const tempNormalizedStockMap = new Map<string, number>();
      normalizedStockMap.forEach((value, key) => {
        tempNormalizedStockMap.set(key, value);
      });

      // Check availability for all items in this order
      for (const roo of ro["orderDetails"]) {
        let caseOQ = roo?.caseQuantity ?? 0;
        let pieceOQ = roo?.pieceQuantity ?? 0;
        let otherUnitOQ = roo?.otherUnitQuantity ?? 0;
        let batchCode = roo?.batchCode ?? "";

        let product = products[batchCode];

        if (uomConversion && product) {
          // Get or calculate normalized order quantity
          let orderDetailsNQ =
            roo?.normalizedQuantity ??
            caseOQ * (product?.caseToPieceQuantity ?? 0) +
              otherUnitOQ * (product?.otherUnitToPieceQuantity ?? 0) +
              pieceOQ;

          // Get normalized stock quantity
          let stockNQ = tempNormalizedStockMap.get(batchCode) ?? 0;

          if (stockNQ === 0) {
            canFulfillCompletely = false;

            // If we need items from this batch and there's no stock for this item
            if (orderDetailsNQ > 0) {
              unFulFillableItems++;
              // Don't break here, continue checking other items
            }
          } else if (stockNQ >= orderDetailsNQ) {
            // We can fulfill this item completely
            // If we have any items with stock, we can at least partially fulfill the order
            if (orderDetailsNQ > 0) {
              canFulfillPartially = true;
            }
          } else {
            // We can only partially fulfill this item
            canFulfillCompletely = false;

            // If there's any stock available and we need this item, we can partially fulfill
            if (orderDetailsNQ > 0 && stockNQ > 0) {
              canFulfillPartially = true;
            }
          }
        } else {
          // Original non-conversion logic
          let [avCs, avPi, avOth] = tempStockMap.has(batchCode)
            ? tempStockMap.get(batchCode) ?? [0, 0, 0]
            : [0, 0, 0];

          // Check if there's no stock at all for this batch code
          if (avCs === 0 && avPi === 0 && avOth === 0) {
            canFulfillCompletely = false;

            if (caseOQ > 0 || pieceOQ > 0 || otherUnitOQ > 0) {
              unFulFillableItems++;
              // Don't break here, continue checking other items
            }
          } else if (
            avCs >= caseOQ &&
            avPi >= pieceOQ &&
            avOth >= otherUnitOQ
          ) {
            // We can fulfill this item completely
            // If we have any items with stock, we can at least partially fulfill the order
            if (caseOQ > 0 || pieceOQ > 0 || otherUnitOQ > 0) {
              canFulfillPartially = true;
            }
          } else {
            canFulfillCompletely = false;

            if (
              (caseOQ > 0 && avCs > 0) ||
              (pieceOQ > 0 && avPi > 0) ||
              (otherUnitOQ > 0 && avOth > 0)
            ) {
              canFulfillPartially = true;
            }
          }
        }
      }

      hasAnyUnfulfillableItems = !(
        unFulFillableItems === ro["orderDetails"]?.length
      );

      // Categorize the order based on our findings
      if (canFulfillCompletely) {
        // Handle complete fulfillment
        if (uomConversion) {
          for (const roo of ro["orderDetails"]) {
            let caseOQ = roo?.caseQuantity ?? 0;
            let pieceOQ = roo?.pieceQuantity ?? 0;
            let otherUnitOQ = roo?.otherUnitQuantity ?? 0;
            let batchCode = roo?.batchCode ?? "";
            let product = products[batchCode];

            if (product && normalizedStockMap.has(batchCode)) {
              // Calculate normalized order quantity
              let orderDetailsNQ =
                roo?.normalizedQuantity ??
                caseOQ * (product?.caseToPieceQuantity ?? 0) +
                  otherUnitOQ * (product?.otherUnitToPieceQuantity ?? 0) +
                  pieceOQ;

              // Deduct from normalized stock
              let currentNQ = normalizedStockMap.get(batchCode) ?? 0;
              normalizedStockMap.set(batchCode, currentNQ - orderDetailsNQ);

              // Also update the original stock map
              if (stockBatchWiseMap.has(batchCode)) {
                let [avCs, avPi, avOth] = stockBatchWiseMap.get(batchCode) ?? [
                  0, 0, 0,
                ];
                stockBatchWiseMap.set(batchCode, [
                  Math.max(0, avCs - caseOQ),
                  Math.max(0, avPi - pieceOQ),
                  Math.max(0, avOth - otherUnitOQ),
                ]);
              }
            }
          }
        } else {
          // Original non-conversion logic for complete fulfillment
          for (const roo of ro["orderDetails"]) {
            let caseOQ = roo?.caseQuantity ?? 0;
            let pieceOQ = roo?.pieceQuantity ?? 0;
            let otherUnitOQ = roo?.otherUnitQuantity ?? 0;
            let batchCode = roo?.batchCode ?? "";

            if (stockBatchWiseMap.has(batchCode)) {
              let [avCs, avPi, avOth] = stockBatchWiseMap.get(batchCode) ?? [
                0, 0, 0,
              ];
              stockBatchWiseMap.set(batchCode, [
                avCs - caseOQ,
                avPi - pieceOQ,
                avOth - otherUnitOQ,
              ]);
            }
          }
        }
        confOrders.push(ro);
      } else if (
        canFulfillPartially ||
        (!canFulfillPartially && hasAnyUnfulfillableItems)
      ) {
        // Handle partial fulfillment - even if some items have zero stock
        if (uomConversion) {
          for (const roo of ro["orderDetails"]) {
            let caseOQ = roo?.caseQuantity ?? 0;
            let pieceOQ = roo?.pieceQuantity ?? 0;
            let otherUnitOQ = roo?.otherUnitQuantity ?? 0;
            let batchCode = roo?.batchCode ?? "";
            let product = products[batchCode];

            if (product && normalizedStockMap.has(batchCode)) {
              // Calculate normalized order quantity
              let orderDetailsNQ =
                roo?.normalizedQuantity ??
                caseOQ * (product?.caseToPieceQuantity ?? 0) +
                  otherUnitOQ * (product?.otherUnitToPieceQuantity ?? 0) +
                  pieceOQ;

              // Get available normalized stock
              let availableNQ = normalizedStockMap.get(batchCode) ?? 0;

              // Determine how much we can fulfill
              let fulfillableNQ = Math.min(availableNQ, orderDetailsNQ);

              if (fulfillableNQ > 0) {
                // Deduct from normalized stock
                normalizedStockMap.set(batchCode, availableNQ - fulfillableNQ);

                // Determine how to distribute the fulfillment across units
                if (stockBatchWiseMap.has(batchCode)) {
                  let [avCs, avPi, avOth] = stockBatchWiseMap.get(
                    batchCode
                  ) ?? [0, 0, 0];

                  // Deduct only what we can fulfill for each unit type
                  let deductCs = Math.min(avCs, caseOQ);
                  let deductPi = Math.min(avPi, pieceOQ);
                  let deductOth = Math.min(avOth, otherUnitOQ);

                  stockBatchWiseMap.set(batchCode, [
                    avCs - deductCs,
                    avPi - deductPi,
                    avOth - deductOth,
                  ]);
                }
              }
            }
          }
        } else {
          // Original non-conversion logic for partial fulfillment
          for (const roo of ro["orderDetails"]) {
            let caseOQ = roo?.caseQuantity ?? 0;
            let pieceOQ = roo?.pieceQuantity ?? 0;
            let otherUnitOQ = roo?.otherUnitQuantity ?? 0;
            let batchCode = roo?.batchCode ?? "";

            if (stockBatchWiseMap.has(batchCode)) {
              let [avCs, avPi, avOth] = stockBatchWiseMap.get(batchCode) ?? [
                0, 0, 0,
              ];

              let deductCs = Math.min(avCs, caseOQ);
              let deductPi = Math.min(avPi, pieceOQ);
              let deductOth = Math.min(avOth, otherUnitOQ);

              stockBatchWiseMap.set(batchCode, [
                avCs - deductCs,
                avPi - deductPi,
                avOth - deductOth,
              ]);
            }
          }
        }
        parOrders.push(ro);
      } else {
        // Cannot fulfill at all
        canOrders.push(ro);
      }
    }
    return {
      confOrders: confOrders,
      parOrders: parOrders,
      canOrders: canOrders
    };
}
